var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrademark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.9448C0 16.4677 4.47715 20.9448 10 20.9448C15.5228 20.9448 20 16.4677 20 10.9448C20 5.42198 15.5228 0.944824 10 0.944824C4.47715 0.944824 0 5.42198 0 10.9448ZM18 10.9448C18 15.3631 14.4183 18.9448 10 18.9448C5.58172 18.9448 2 15.3631 2 10.9448C2 6.52655 5.58172 2.94482 10 2.94482C14.4183 2.94482 18 6.52655 18 10.9448Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.9448C0 16.4677 4.47715 20.9448 10 20.9448C15.5228 20.9448 20 16.4677 20 10.9448C20 5.42198 15.5228 0.944824 10 0.944824C4.47715 0.944824 0 5.42198 0 10.9448ZM18 10.9448C18 15.3631 14.4183 18.9448 10 18.9448C5.58172 18.9448 2 15.3631 2 10.9448C2 6.52655 5.58172 2.94482 10 2.94482C14.4183 2.94482 18 6.52655 18 10.9448Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 13.4448H5.71094V8.7417H4.16016V7.73389H8.47266V8.7417H6.92188V13.4448ZM11.7695 13.4448L10.3945 8.96436H10.3594C10.4089 9.87581 10.4336 10.4839 10.4336 10.7886V13.4448H9.35156V7.73389H11L12.3516 12.1011H12.375L13.8086 7.73389H15.457V13.4448H14.3281V10.7417C14.3281 10.6141 14.3294 10.467 14.332 10.3003C14.3372 10.1336 14.3555 9.69092 14.3867 8.97217H14.3516L12.8789 13.4448H11.7695Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademark);
export default __webpack_public_path__ + "static/media/trademark.0857128b8f4e82d81e829af66d20284c.svg";
export { ForwardRef as ReactComponent };